import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './../../styles/cliente/referidos.css';
import * as globals from '../../components/GlobalScripts.js';

const Cliente_referidos = () => {
    const [accounts, setAccounts] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    const path_api = localStorage.getItem('path_api');
    const itemsPerPage = 10;

    const get_clients = (page = 1, search = '') => {
        globals.openViewCharge();
        axios.post(`${path_api}/update-clients/get_clients_referrer_client.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            page: page,
            itemsPerPage: itemsPerPage,
            search: search,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setAccounts(response.data.accounts);
                setTotalPages(response.data.totalPages);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se obtuvieron los clientes",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar los clientes",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    useEffect(() => {
        get_clients(currentPage, search);
    }, [currentPage]);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSearchChangeE = (e) => {
        get_clients(currentPage, e.target.value);
    };

    const handlePrevPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const handleNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    const handleClaim = (keylogin) => {
        globals.openViewCharge();
        axios.post(`${path_api}/update-clients/claim_reward.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            referred: keylogin
        }).then(response => {
            if (response.data.mensaje === 'success') {
                get_clients(currentPage, search);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se reclamaron las recompensas",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al reclamar las recompensas",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        }).finally(() => {
            globals.closeViewCharge();
        });
    };

    return (
        <div className="page-referidos container-section flex-column gap-20">
            <h3>Listado de referidos</h3>
            <div className="container-search">
                <div className='search'>
                    <label>Filtra por correo:</label>
                    <input
                        type="text"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={(e) => { if (e.key === 'Enter') handleSearchChangeE(e); }}
                        className="input-primary"
                        placeholder="Preciona enter para buscar"
                    />
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Correo electronico</th>
                        <th>Recompensa</th>
                    </tr>
                </thead>
                <tbody>
                    {accounts.map(account => (
                        <tr key={account.keylogin}>
                            <td>{account.email}</td>
                            <td className="table-actions">
                                {account.rewardAvailable > 0 && (
                                    <button className="edit-button" onClick={() => handleClaim(account.keylogin)} title='Reclamar'>
                                        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g>
                                                <path d="M18.75 15.625C18.75 11.481 20.3962 7.50671 23.3265 4.57646C26.2567 1.6462 30.231 0 34.375 0C38.519 0 42.4933 1.6462 45.4235 4.57646C48.3538 7.50671 50 11.481 50 15.625C50 11.481 51.6462 7.50671 54.5765 4.57646C57.5067 1.6462 61.481 0 65.625 0C69.769 0 73.7433 1.6462 76.6735 4.57646C79.6038 7.50671 81.25 11.481 81.25 15.625V15.6625C81.25 16.1 81.25 17.35 81.0125 18.75H93.75C95.4076 18.75 96.9973 19.4085 98.1694 20.5806C99.3415 21.7527 100 23.3424 100 25V31.25C100 32.9076 99.3415 34.4973 98.1694 35.6694C96.9973 36.8415 95.4076 37.5 93.75 37.5H6.25C4.5924 37.5 3.00269 36.8415 1.83058 35.6694C0.65848 34.4973 0 32.9076 0 31.25V25C0 23.3424 0.65848 21.7527 1.83058 20.5806C3.00269 19.4085 4.5924 18.75 6.25 18.75H18.9875C18.8233 17.7291 18.7439 16.6965 18.75 15.6625V15.625ZM25.425 18.75H43.75V15.625C43.75 14.3939 43.5075 13.1748 43.0364 12.0373C42.5652 10.8999 41.8747 9.86642 41.0041 8.99587C40.1336 8.12532 39.1001 7.43477 37.9627 6.96363C36.8252 6.49249 35.6061 6.25 34.375 6.25C33.1439 6.25 31.9248 6.49249 30.7873 6.96363C29.6499 7.43477 28.6164 8.12532 27.7459 8.99587C26.8753 9.86642 26.1848 10.8999 25.7136 12.0373C25.2425 13.1748 25 14.3939 25 15.625C25 16.1563 25.0125 17.3375 25.2813 18.3125L25.425 18.75ZM56.25 18.75H74.575L74.7187 18.3125C74.9875 17.3375 75 16.1563 75 15.625C75 13.1386 74.0123 10.754 72.2541 8.99587C70.496 7.23772 68.1114 6.25 65.625 6.25C63.1386 6.25 60.754 7.23772 58.9959 8.99587C57.2377 10.754 56.25 13.1386 56.25 15.625V18.75ZM93.75 43.75V90.625C93.75 93.1114 92.7623 95.496 91.0041 97.2541C89.246 99.0123 86.8614 100 84.375 100H56.25V43.75H93.75ZM15.625 100C13.1386 100 10.754 99.0123 8.99587 97.2541C7.23772 95.496 6.25 93.1114 6.25 90.625V43.75H43.75V100H15.625Z" fill="black" />
                                            </g>
                                        </svg>

                                    </button>
                                )}
                                {account.rewardAvailable == 0 && (
                                    <p>N/A</p>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                <button className="button-pagination" onClick={handlePrevPage} disabled={currentPage === 1}>
                    Anterior
                </button>
                <p>Página {currentPage} de {totalPages}</p>
                <button className="button-pagination" onClick={handleNextPage} disabled={currentPage === totalPages}>
                    Siguiente
                </button>
            </div>
        </div>
    );
};

export default Cliente_referidos;